module.exports = __webpack_public_path__ + "img/assassin_small.3c3e7f91.png";